import { render, staticRenderFns } from "./Liangtang.vue?vue&type=template&id=ca58e680&"
import script from "./Liangtang.vue?vue&type=script&lang=js&"
export * from "./Liangtang.vue?vue&type=script&lang=js&"
import style0 from "./Liangtang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports